import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import * as moment from 'moment';
import { Remesa } from 'src/app/interfaces/remesa.interface';
import { VentaService } from 'src/app/services/venta.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-remesas',
  templateUrl: './remesas.component.html',
  styleUrls: ['./remesas.component.css']
})
export class RemesasComponent implements OnInit {
  remesaForm = this.fb.group({
    fecha: [moment().format('YYYY-MM-DD HH:mm:ss')],
    monto: ['', [Validators.required, Validators.min(1)]]
  });

  constructor(
    private fb: FormBuilder,
    private router: Router,
    public ventaService: VentaService
  ) { }

  ngOnInit(): void {
  }

  agregarDigito(numero: string) {
    let cantidad: string = this.remesaForm.controls.monto.value;
    if (!cantidad) {
      cantidad = numero
    } else {
      cantidad = cantidad + numero;
    }
    this.remesaForm.controls.monto.setValue(Number.parseInt(cantidad, 10));
  }

  borrarDigito() {
    let cantidad: string = this.remesaForm.controls.monto.value.toString();
    if (!cantidad) {
      return;
    }

    if (cantidad.length === 1) {
      this.remesaForm.controls.monto.setValue('');
      return;
    }

    const ultIndex = cantidad.length - 1;
    cantidad = cantidad.substring(0, ultIndex);

    this.remesaForm.controls.monto.setValue(cantidad);
  }

  async guardarRemesa() {
    if (this.remesaForm.controls.monto.invalid) {
      this.remesaForm.controls.monto.setValue('');
      return
    }

    const monto = Number.parseInt(this.remesaForm.controls.monto.value);
    const remesa: Remesa = {
      fecha: this.remesaForm.controls.fecha.value,
      monto
    };

    this.ventaService.caja.remesas.push(remesa);
    await this.ventaService.actualizarRemesa();
    this.router.navigateByUrl('/venta');
  }

}
